import './popover.scss';

export const POPOVER_TEMPLATE_URL = 'javascripts/app/components/core/popover/popover.html';

export interface Popover {
  getTitle(): string;
  getDescription(): string;
  open?: boolean;
}

export class PopoverManager {
  constructor(private readonly popovers: Record<string, Popover>) {}

  getTitle(popoverId: string) {
    return this.popovers[popoverId].getTitle();
  }

  getDescription(popoverId: string) {
    return this.popovers[popoverId].getDescription();
  }

  close(popoverId: string) {
    this.popovers[popoverId].open = false;
  }

  isOpen(popoverId: string) {
    return Boolean(this.popovers[popoverId].open);
  }
}
